import { styled, TableCell as MuiTableCell } from '@mui/material';

export const FooterCell = styled(MuiTableCell)(() => ({
  padding: 10,
  height: 60,
}));
